// React&NextJS
import React from 'react'
// Styles
import s from '../Authentication.module.scss'
// Components
import { Container } from '../../../core/container/Container'
import { Text } from '../../../core/text/Text'
import { WhiteBox } from '../../../core/whiteBox/WhiteBox'

const RafraenLoading = ({ closeButton = null }) => {
    return (
        <Container>
            <WhiteBox className={s.container}>
                {closeButton}
                <Text variant="h2">Rafræn auðkenning</Text>
                <Text variant="p-18">Auðkenning í síma bíður samþykkis...</Text>
                <div className={s.loader}>
                    <div className={s.loaderInside}></div>
                </div>
            </WhiteBox>
        </Container>
    )
}

export default RafraenLoading
